import type { CoworkArtifact, CoworkSessionContext } from "./api"

export function artifactsForChat(
  artifacts: CoworkArtifact[],
  context: CoworkSessionContext | undefined,
  remoteSessionID: string | undefined,
) {
  if (!context || !remoteSessionID || context.remote_opencode_session_id !== remoteSessionID) return []
  return artifacts.filter(
    (artifact) =>
      artifact.company_id === context.company_id &&
      artifact.project_id === context.project_id &&
      artifact.session_id === context.session_id &&
      artifact.status !== "deleted",
  )
}

export function artifactDownloadPath(href: string, pageURL: string, apiURL: string) {
  try {
    const page = new URL(pageURL)
    const api = new URL(apiURL, page)
    const url = new URL(href, page)
    if (!/^https?:$/.test(url.protocol) || url.username || url.password) return
    if (url.origin !== page.origin && url.origin !== api.origin) return
    const prefix = api.pathname.replace(/\/$/, "")
    const path =
      url.origin === api.origin && prefix && url.pathname.startsWith(`${prefix}/`)
        ? url.pathname.slice(prefix.length)
        : url.pathname
    if (
      /^\/api\/reports\/[\w-]+\/download\/?$/.test(path) ||
      /^\/api\/projects\/[\w-]+\/artifacts\/[\w-]+\/download\/?$/.test(path) ||
      /^\/api\/projects\/[\w-]+\/workflows\/[\w-]+\/runs\/[\w-]+\/artifacts\/[\w-]+\/download\/?$/.test(path)
    )
      return path.replace(/\/$/, "")
  } catch {
    return
  }
}

export function artifactDownloadPageURL(pageURL: string, apiURL: string) {
  if (/^https?:\/\//.test(pageURL)) return pageURL
  return new URL(apiURL || "/", "http://localhost/").href
}

export function handleArtifactDownloadClick(event: MouseEvent, apiURL: string, download: (path: string) => void) {
  if (event.defaultPrevented || event.button !== 0) return
  const target = event.target
  if (!(target instanceof Element)) return
  const anchor = target.closest("a[href]")
  if (!anchor || !event.currentTarget || !(event.currentTarget as Element).contains(anchor)) return
  const path = artifactDownloadPath(anchor.getAttribute("href")!, window.location.href, apiURL)
  if (!path) return
  event.preventDefault()
  event.stopPropagation()
  download(path)
}

export function saveArtifactDownload(result: { blob: Blob; filename: string }) {
  const url = URL.createObjectURL(result.blob)
  const link = document.createElement("a")
  link.href = url
  link.download = result.filename
  document.body.appendChild(link)
  try {
    link.click()
  } finally {
    link.remove()
    // Let the browser start reading the blob before releasing its URL.
    setTimeout(() => URL.revokeObjectURL(url), 1_000)
  }
}
